import { InstagramStoryPost } from '@anytag/graphql';
import { TableV2, TableV2Props } from '@anytag/shared-atoms';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerInstagramAnalyticsStoryDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsInstagramStoryPostsListTable } from './hooks/useAnalyticsInstagramStoryPostsListTable';

export interface AnalyticsInstagramStoryPostsListProps extends TableData<InstagramStoryPost> {
  mainSocialAccountId?: number;
  tableRef?: TableV2Props<InstagramStoryPost>['reactTableRef'];
}

export const AnalyticsInstagramStoryPostsList = ({
  loading,
  tableRef,
  data = [],
  mainSocialAccountId
}: AnalyticsInstagramStoryPostsListProps) => {
  const { columns } = useAnalyticsInstagramStoryPostsListTable();

  return (
    <>
      <TableV2
        data={data}
        loading={loading}
        columns={columns}
        rowHeight="62px"
        reactTableRef={tableRef}
        noTopBorderRadius
        hasBorder
      />

      <InfluencerInstagramAnalyticsStoryDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics
      />
    </>
  );
};
